import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#F5E6E0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">KOREDAKE wellness protein</span>
        </div>
      </header>

      {/* Breadcrumb Navigation */}
      <nav className="bg-[#FFF9F7] border-b border-[#F5E6E0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a 
                href="https://soyproteinranking.com/" 
                className="flex items-center gap-2 text-[#D4A59A] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#E8D4CF]">/</li>
            <li className="text-[#6B5750] whitespace-nowrap">KOREDAKEで自分らしい健やかな毎日を</li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <div className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#D4A59A] px-6 py-4 rounded-lg leading-tight">
            KOREDAKEで自分らしい健やかな毎日をデザインする
          </h1>
          <p className="text-[#6B5750] leading-relaxed mb-4">
            「忙しくて食事がおろそかになる」「美容も健康も妥協したくない」「本当に体によいものだけを摂りたい」と感じていませんか？
          </p>
          <p className="text-[#6B5750] leading-relaxed">
            <span className="text-[#bc6355] font-semibold underline decoration-[#F5E6E0] decoration-4">
              KOREDAKE（コレダケ）
            </span>
            は、
            <span className="border-b-2 border-[#bc6355] font-semibold">
              女性に不足しがちな31種類の栄養素
            </span>
            を配合し、1食分をこれ一杯に置き換えられる完全栄養プロテインです。
          </p>
        </div>

        {/* Features Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            KOREDAKEの特徴や概要
          </h2>
          <p className="text-[#6B5750] leading-relaxed mb-6">
            <span className="text-[#bc6355] font-semibold">KOREDAKE wellness protein</span>
            は、「心身の健康」と「素材へのこだわり」に特化した、これまでにないウェルネスプロテインです。
          </p>
          <p className="text-[#6B5750] leading-relaxed mb-8">
            最大の特徴は、
            <span className="border-b-2 border-[#bc6355] font-semibold">
              100%植物性のソイプロテイン
            </span>
            でありながら、驚くほど美味しいこと。管理栄養士監修のもと、1日に必要な栄養素をバランスよく補給できます。
          </p>

          <h3 className="text-xl font-bold text-[#6B5750] mb-6">KOREDAKEがひと目でわかる!</h3>
          <div className="overflow-hidden rounded-lg border border-[#F5E6E0] shadow-sm mb-8 bg-white">
            <table className="w-full">
              <thead>
                <tr className="bg-[#FFF9F7]">
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0] w-1/3">
                    項目
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0]">
                    内容
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#F5E6E0]">
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">主な機能性</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">31種類の栄養素をカバーする完全食</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">注目成分</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">大豆タンパク / 食物繊維 / 26種のビタミン＆ミネラル</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">安全性</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">国内認定工場で製造</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">美容成分</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">MCTオイル / プラセンタ　</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">利便性</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">溶けやすく、忙しい朝の1食置き換えに最適</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Usage Points Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            KOREDAKEの活用ポイント
          </h2>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              1.「これ一杯」で理想の栄養バランス
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              厚生労働省が定める「日本人の食事摂取基準」に基づき、女性に不足しがちな栄養素を網羅。
              <strong className="text-[#bc6355]">「ラクして健康」</strong>
              を叶える黄金比率の配合です。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              2.女性に嬉しい「美容成分たっぷり配合」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              <strong className="text-[#bc6355]">毎日飲むものだから</strong>
              MCTオイル、食物繊維、乳酸菌、プラセンタなど、健康とキレイのどちらも叶えることができます。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              3.美味しく満たされる「続けたくなる体験」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              プロテインとは思えない
              <strong className="text-[#bc6355]">上品で濃厚な味わい</strong>
              。ソイの満足感と豊富な食物繊維が腹持ちをサポートし、心も体も心地よく満たされます。
            </p>
          </div>
        </section>

        {/* Recommended For Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            KOREDAKEはこんな人におすすめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                CHECK!
              </span>
            </div>
            <ol className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  1
                </div>
                <p className="text-[#6B5750]">朝食を抜いてしまいがちで、手軽に栄養を摂りたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  2
                </div>
                <p className="text-[#6B5750]">添加物が気になるので、素材にこだわったものを選びたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  3
                </div>
                <p className="text-[#6B5750]">置き換えダイエット中も、肌や髪の美容成分まで補いたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  4
                </div>
                <p className="text-[#6B5750]">人工的な甘さが苦手。自然で贅沢な美味しさを楽しみたい</p>
              </li>
            </ol>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                POINT
              </span>
            </div>
            <div className="space-y-4 text-[#6B5750]">
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">究極の1食:</strong> 1杯で31種類の栄養素を補える完全食プロテイン
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">クリーンラベル:</strong> 合成甘味料・着色料など不使用の安心・安全処方
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">美容成分配合:</strong> ダイエットをしながら美しさもサポートする贅沢配合
                </span>
              </p>
            </div>
          </div>
          <p className="text-[#6B5750] leading-relaxed mt-8 text-center font-bold">
            「がんばらない、健康」で、心地よい毎日を始めてみませんか。
          </p>

          {/* Product Image */}
          <a
            href="https://soyproteinranking.com/web/KOREDAKE.php?p=sh"
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-12 cursor-pointer hover:opacity-90 transition-opacity"
          >
            <div className="w-full h-auto">
              <img
                alt="KOREDAKE wellness protein - 完全栄養プロテイン"
                className="w-full h-auto rounded-lg shadow-md object-cover"
                src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/5be692d9b18d16cde81a3aa5dbe313cb.png"
              />
            </div>
          </a>

          {/* CTA Section */}
          <div className="mt-8 bg-[#bc6355] rounded-lg py-8 px-6 text-center">
            <p className="text-white text-sm font-medium mb-4 tracking-wide">
              累計販売数 100万食突破！
            </p>
            <a
              href="https://soyproteinranking.com/web/KOREDAKE.php?p=sh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#FFF9F7] rounded-lg px-8 py-4 mb-6 cursor-pointer hover:shadow-lg transition-shadow"
            >
              <p className="text-[#8B7B74] text-xs mb-1">ウェルネスプロテイン</p>
              <p className="text-[#bc6355] text-2xl font-bold tracking-wide">KOREDAKE</p>
              <p className="text-[#bc6355] text-xs tracking-widest">wellness protein</p>
            </a>
            <div>
              <a
                href="https://soyproteinranking.com/web/KOREDAKE.php?p=sh"
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-block bg-white text-[#bc6355] font-bold py-4 px-12 rounded-full cursor-pointer hover:shadow-lg transition-all overflow-hidden group whitespace-nowrap"
              >
                <span className="relative z-10">KOREDAKEの詳細を見る</span>
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
